function pw_post_product_modal_save(personalisationID, thumbURL){

  $("img.pswp__img").attr("src", thumbURL);

}


document.addEventListener('DOMContentLoaded', function load() {
    if (!window.jQuery) return setTimeout(load, 50);
    
  	 var pw_button = $("#pw_cart_button");
     var staticProduct = $("#pw_static_product");
  
     if ($(".product").length && (pw_button.length || staticProduct.length) ){
        setTimeout(function(){ 
       		$(".shopify-payment-button").hide();
         },1000);
       
       $(document).on("change", ".selector-wrapper select", function(e){
       	$(".shopify-payment-button").hide();
       });
     }

    if($(".product").length && pw_button.length){
      $("body").addClass("pw-product");
        
      function personaliseButton(){

        $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {

          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Personalise"){
            $('#pw_cart_button').val('Edit');
            setTimeout(function(){ 
              $(".pwAddToCart").show();
              $('.pwAddToCart').prop('disabled', false);
            },1000);
          } 

        });


        // Select the node that will be observed for mutations
        var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {

            var pw_button_text = $("#pw_cart_button").val();
            if(pw_button_text == "Personalise"){
              $('#pw_cart_button').val('Edit');
              setTimeout(function(){ 
                $(".pwAddToCart").show();
                 $('.pwAddToCart').prop('disabled', false);
              },1000);
            }
          }

        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        var pw_button = $("#pw_cart_button");
        if (typeof pw_button  !== "undefined"){
          setTimeout(function(){
            $(".shopify-payment-button, .pwAddToCart").hide();
          },3000);

        }
      }

      personaliseButton();

      $(document).on("click", ".product__media-zoom", function(){
          console.log("CLICK ZOOM");
          var product_image = $(".product__media img").attr('src');
          console.log(product_image);
          setTimeout(function(){ 
            $("img.pswp__img").attr("srcset", product_image);
            $("img.pswp__img").attr("src", product_image);
          },1000);
        
        
      });

      $(document).on("click", ".pwAddToCart, a.cart-drawer-button", function(){
        setTimeout(function(){ 
            replacePWimages();
        },2000);
      });
      
      function pwVariationChange(){

        

        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Edit"){
			            
            var product_image_original = $('meta[property="og:image"]').attr('content');
			
            setTimeout(function(){ 
    
              $(".product__media img").attr("data-src", product_image_original);
              $(".product__media img").attr("data-bgset", product_image_original);
              $(".product__media img").attr("src", product_image_original);
              $(".product__media img").attr("srcset", product_image_original);

            }, 500);
           
            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
              $("#pw_cart_button").prop('value', 'Personalise');
            } else{
              $('#pw_cart_button').val('Personalise');
            }


            
          }

          
          
          setTimeout(function(){ 
            $('.pwProductSelect option').removeAttr('selected');
              $(".shopify-payment-button, .pwAddToCart").hide();
             var variantID = $(".product-variant-id").val();
             console.log(variantID);
              $('.pwProductSelect option[value='+variantID+']').attr('selected','selected');
             
           },500);
        }

      }
      var variantID = $(".product-variant-id").val();
      $('.pwProductSelect option[value='+variantID+']').attr('selected','selected');
      $(document).on("click", "fieldset.js.product-form__input label", function(e){
  		  console.log('clicked label');
         pwVariationChange();

      });

    function replacePWimages(){

      var optionsBlocks = $("cart-items .cart-item .cart-item__details .cart-item__options:contains('PersonalisationID')");
      
      optionsBlocks.each(function() {
        var $options = $(this);

        // Find the <dt> that says "PersonalisationID" and grab its matching <dd>
        var $dt = $options.find("dt").filter(function() {
          return $(this).text().indexOf("PersonalisationID") !== -1;
        });

        if ($dt.length === 0) return; // no PersonalisationID in this item, skip

        var cardID = $dt.next("dd").text().trim();

        if (!cardID) return;

        var rand = Math.floor(Math.random() * 10000);
        var newSrc = "https://pwcdn.net/thumbnails/11852/" + cardID + ".jpg?r=" + rand;

        // Go up to the whole cart item, THEN find the image
        var $item = $options.closest(".cart-item");
        var $img = $item.find("img");

        $img.addClass("pwThumbImage");
        $img.attr("src", newSrc);
        $img.attr("srcset", newSrc);
      });

    }

    }

    // opens the Printzware Modal Window
  function opendialog(page) {
    document.ontouchmove = function (e) {
      e.preventDefault();
    }
    // if it's a product call use the correct ModalUrl
    if(pwProductMode) {
        if (pwProductSelect !== null) {
          var pwSelectedVariant;
          // if the pwProductSelect is an INPUT field
          if(pwProductSelect !== null && pwProductSelect.prop('nodeName')=='INPUT'){
        if(pwProductSelect.attr('pwdata-sku')){
                pwSelectedVariant = pwProductSelect.attr('pwdata-sku').split("-");
        }else{
          pwSelectedVariant = pwVariant2pwSku[pwProductSelect.val()].split("-")
        }
          } else {// else as normal select > option
            pwSelectedVariant = pwProductSelect.find(":selected").attr('pwdata-sku').split("-");
          }

          page = urldecode(pwModalUrls[pwSelectedVariant[0]]);

          //check if an product option  has been specific and add it to the Modal URL
          if(typeof pwSelectedVariant[1] !== 'undefined') {
            page = page + pwSelectedVariant[1];
          }
        }
    }

    // Check if viewport exists and save original content, apply mobile non-zoom viewport
    viewport = document.querySelector("meta[name=viewport]");
    if (viewport!=null){
      // save the original viewport settings
      origViewportString = viewport.content;
      // set the new viewport to disable zoom on mobile
      viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
    }
    else{
      origViewportString = "";
      var metaTag=document.createEulement('meta');
      metaTag.name = "viewport"
      metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
      document.getElementsByTagName('head')[0].appendChild(metaTag);
    }

    if (typeof pwJsonData !== 'undefined') {
      page = page + pwJsonData;
    }

    $j('#pw_iframe').attr('src',page);
    if (typeof pw_disable_scrolltop === 'undefined'){
      $j('body').css({'top': ($j(window).scrollTop() * -1)+'px'});
    }
    $j('#pw_modal').addClass('in');
    $j('#pw_modal').modal('show');
    $j('body').addClass('pw-modal-open');
    $j('#pw_modal').show();
    $j('.modal-backdrop').detach().appendTo('.bootstrap-wrapper');
    $j('.modal-backdrop').click(function(){
      closeDialog();
    });
  }

  
  
}, false);

  
